<script>
import { timeslotService } from "../../services";
import { required , requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import { minMax } from "../../Helper/formValidation";

export default {
    components: { timeslotService, Layout, PageHeader, Multiselect, DatePicker},
    data() {
        return {
            checked: true,
            url: null,
            config: config,
            days: [],
            disabled: true,
            isLoading: false,
            day_type: "",
            del_type: "",
            today: "",
            available_drivers: 0,
            busy_drivers: 0,
            max: 1,
            typeform: {
                from_time: "",
                to_time: "",
                delivery_type: "1",
                order_limit: "",
                status: "1",
                type: "",
                customer_type: 2,
                value: "",
                cust_type_search:"",
                slectedDays:[],
            },
            allDays:[
                {day:'Monday',driver:1},
                {day:'Tuesday',driver:1},
                {day:'Wednesday',driver:1},
                {day:'Thursday',driver:1},
                {day:'Friday',driver:1},
                {day:'Saturday',driver:1},
                {day:'Sunday',driver:1},
            ],
        };
    },
    validations: {
        typeform: {
            from_time:{
                required,
            },
            to_time:{
                required,
            },
            delivery_type:{
                required,
            },
            type:{
                required,
            },
            cust_type_search: {
                required : requiredIf(function(form){
                    return this.day_type == 1;
                }),
            },
            customer_type:{
                required,
            },
            slectedDays: {
                $each: {
                    day: {
                        required,
                    },
                    driver: {
                        required,
                    },
                },
            },
        }
    },
    mounted(){
        this.getTimeSlotById();
    },
    methods: {
        // addMulti(data){
        //     this.typeform = {
        //         ...this.typeform,
        //         cust_type_search : [...data]
        //     }
        // },
        onTypeChange(){
            this.typeform.slectedDays = "";
            this.typeform.cust_type_search = "";
            this.day_type = this.typeform.type;
            if(this.typeform.type == '0'){
                this.typeform.slectedDays = this.allDays;
            }else if(this.typeform.type == '2'){
                this.typeform.slectedDays = [{day:'Today',driver:1}]
            }
        },
        onTypeChangeType(){
       
            timeslotService.getDataCustomerType(this.typeform)
            .then(response => {
           
                if(response.data.code == 200){
                    this.available_drivers = response.data.result.available_drivers;
                    this.busy_drivers = response.data.result.busy_drivers;
                    this.max = response.data.result.available_drivers;
                }
                else {
                    error_message(response.data.message);
                }
            });
        },
        onTypeSpecialDay(data){
              this.typeform = {
                ...this.typeform,
                cust_type_search : [...data]
            }
            this.typeform.slectedDays = this.typeform.cust_type_search;
            
        },
        onDeliveryChange(){
            this.del_type = this.typeform.delivery_type;
        },
        clearAll() {
            this.slectedDays = [];
        },
        minMax,
        getTimeSlotById(){
            timeslotService.getTimeSlotById({id: this.$route.params.id, type:'edit' })
            .then(response => {
                const{ id, from_time, to_time, status, customer_type, delivery_type, time_id, timeslot_id, available_drivers, busy_drivers, type} = response.data.result;
                this.typeform.id = id;
                this.typeform.from_time = from_time;
                this.typeform.to_time = to_time;
                this.typeform.status = status;
                this.typeform.customer_type = customer_type;
                this.typeform.delivery_type = delivery_type;
                this.typeform.time_id = time_id;
                this.typeform.timeslot_id = timeslot_id;
                this.typeform.type = response.data.result.type;
                this.available_drivers = available_drivers;
                this.busy_drivers = busy_drivers;
                this.day_type = response.data.result.type;
                this.del_type = response.data.result.delivery_type;
                this.max = available_drivers;

                if(this.day_type == 1){
                    this.typeform.cust_type_search = response.data.result.value;
                    this.typeform.slectedDays = response.data.result.value;
                    // this.typeform.cust_type_search = [...response.data.result.cust_type_search.split(",")];
                }else{
                    this.typeform.cust_type_search = "";
                    this.typeform.slectedDays = response.data.result.value;
                }
                // }else if(this.day_type == 2){
                //     this.today = response.data.result.cust_type_search;
                //     this.typeform.cust_type_search = []; 
                // }else{
                //     this.typeform.cust_type_search = [];
                // }
            });
        },
        editTimeSlot(){
           
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                return;
            } else {
                timeslotService.editTimeSlot(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        this.$router.push({ name: "time-slot-list" });
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        getDisabledStartTime(date){
            var rs = false
            if(this.typeform.to_time!== '' && !rs){
                if(this.moment(date).isSame(this.moment(this.typeform.to_time,'H:mm'))){
                    rs = true;
                }
                // if(this.moment(date).isSameOrAfter(this.moment(this.typeform.to_time,'H:mm'))){
                //     rs = true;
                // }
            }
            return rs;
        },
        getDisabledEndTime(date){
            var rs = false
            if(this.typeform.from_time !== '' && !rs){
                if(this.moment(date).isSame(this.moment(this.typeform.from_time,'H:mm'))){
                    rs = true;
                }
                // if(this.moment(date).isSameOrBefore(this.moment(this.typeform.from_time,'H:mm'))){
                //     rs = true;
                // }
            }
            return rs;
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 49 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        limitDriverInput(event, index) {
        // Get the current value from the event target (input field)
        let value = Number(event.target.value);
        // If the value exceeds available_drivers, set it to available_drivers
        if (event.target.value == "") {
            this.typeform.slectedDays[index].driver = "";
        } else {
            if (value > this.available_drivers) {
                this.typeform.slectedDays[index].driver = this.available_drivers;
                event.target.value = this.available_drivers;  // Update the input value directly
            }else {
                this.typeform.slectedDays[index].driver = value;  // Set the correct value
            }
        }
    },  
    },
};

</script>
<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left avatar-main-icon">
                        <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-briefcase"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18">{{ typeform.from_time +' - '+ typeform.to_time}}</h4>
                            <p>
                                <router-link :to="{name: 'time-slot-list',params: { brand_id:base64(typeform.id)}}">{{ trans.get('__JSON__.Time Slots') }}</router-link>
                                > {{ typeform.from_time +' - '+ typeform.to_time }}
                            </p> 
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="editTimeSlot">
                    <div class="card">
                        <div class="card-body">
                            <p class="card-title-desc"></p>
                            <div class="row">

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.From Time')}}</label>
                                        <!-- :disabled-time="function(date){return getDisabledStartTime(date)}" -->
                                        <date-picker
                                            v-model="typeform.from_time"
                                            :time-picker-options="{
                                                start: '00:00',
                                                step: '01:00',
                                                end: '23:00',
                                            }"
                                            format="H:mm"
                                            type="time"
                                            class="date-time"
                                            placeholder="H:mm"
                                            name="from_time"
                                            valueType="format"
                                            :editable="false"
                                            :class="{ 'is-invalid':$v.typeform.from_time.$error }"
                                            :disabled="disabled"
                                        ></date-picker>
                                        <div v-if="$v.typeform.from_time.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.from_time.required">{{ trans.get('__JSON__.Please select from time') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- :disabled-time="function(date){return getDisabledEndTime(date)}" -->
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.To Time')}}</label>
                                        <date-picker
                                            v-model="typeform.to_time"
                                            :time-picker-options="{
                                                start: '00:00',
                                                step: '01:00',
                                                end: '23:00',
                                            }"
                                            format="H:mm"
                                            type="time"
                                            class="date-time"
                                            placeholder="H:mm"
                                            name="to_time"
                                            valueType="format"
                                            :editable="false"
                                            :class="{ 'is-invalid':$v.typeform.to_time.$error }"
                                            :disabled="disabled"
                                            
                                        ></date-picker>
                                        <div v-if="$v.typeform.to_time.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.to_time.required">{{ trans.get('__JSON__.Please select to time') }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Delivery Type & Time Slots')}}</label>
                                        <select class="custom-select" v-model="$v.typeform.delivery_type.$model" id="delivery_type" name="delivery_type" :class="{ 'is-invalid':$v.typeform.delivery_type.$error }" @change="onDeliveryChange()">
                                            <option value="">{{trans.get('__JSON__.Select Delivery Type')}}</option>
                                            <option value="0">{{trans.get('__JSON__.Both')}}</option>
                                            <option value="1">{{trans.get('__JSON__.Delivery')}}</option>
                                            <option value="2">{{trans.get('__JSON__.Pickup')}}</option>
                                        </select>
                                        <div v-if="$v.typeform.delivery_type.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.delivery_type.required">{{ trans.get('__JSON__.Please select delivery type') }}</span>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Days Selection')}}</label>
                                        <select class="custom-select" v-model="$v.typeform.type.$model" id="type" name="type" :class="{ 'is-invalid':$v.typeform.type.$error }" @change="onTypeChange()">
                                            <option value="">{{trans.get('__JSON__.Select Days Type')}}</option>
                                            <option value="0">{{trans.get('__JSON__.All Days')}}</option>
                                            <option value="1">{{trans.get('__JSON__.Special Days')}}</option>
                                            <option value="2">{{trans.get('__JSON__.Today')}}</option>
                                        </select>
                                        <div v-if="$v.typeform.type.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.type.required">{{ trans.get('__JSON__.Please select days type') }}</span>
                                        </div>
                                    </div>
                                </div>
                              
                                <div class="col-sm-6" v-if="this.day_type == 1">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Days')}}</label>
                                        <multiselect 
                                        :multiple="true" 
                                        :value="$v.typeform.cust_type_search.$model"  
                                        label="day"
                                        track-by="day"
                                        :options="allDays" 
                                        @input="onTypeSpecialDay"
                                        :class="{ 'is-invalid': $v.typeform.cust_type_search.$error }">
                                        </multiselect>
                                        <div v-if="$v.typeform.cust_type_search.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.cust_type_search.required">{{ trans.get('__JSON__.Please select days') }}</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- <div class="col-sm-6" v-if="this.day_type == 2">
                                    <div class="form-group">
                                        <label>{{ trans.trans('__JSON__.Date Selected As Today')}}</label>
                                        <h5 class="font-size-14">{{ moment(this.today).format('MM-DD-YYYY') }}</h5>
                                    </div>
                                </div> -->

                                <!-- <div class="col-sm-6" v-if="this.del_type != 2">
                                    <div class="form-group">
                                        <label class="required">{{ trans.trans('__JSON__.Order Limit')}}</label>
                                        <input
                                            maxlength="3"
                                            minlength="1"
                                            id="order_limit"
                                            v-model="$v.typeform.order_limit.$model"
                                            type="text"
                                            class="form-control"
                                            :placeholder="trans.trans('__JSON__.Order Limit')"
                                            name="order_limit"
                                            @keypress="contactNumber($event)"
                                            :class="{ 'is-invalid': $v.typeform.order_limit.$error }"
                                        />
                                        <div v-if="$v.typeform.order_limit.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.order_limit.required">{{ trans.get('__JSON__.Please enter order limit') }}</span>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="col-md-6 vendor-status">
                                    <b-form-group
                                        id="input-group-2"
                                        :label="trans.get('__JSON__.Status')"
                                        label-for="Status"
                                    >
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="swtich-data">
                                                    <label class="switch">
                                                        <input
                                                        type="checkbox"
                                                        id="togBtn"
                                                        class="switch-on"
                                                        name="status"
                                                        v-model="typeform.status"
                                                        true-value="1"
                                                        false-value="0"
                                                        />
                                                        <div class="slider round">
                                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group
                                        id="input-group-2"
                                        :label="trans.get('__JSON__.Customer Type')"
                                        label-for="Customer Type"
                                    >      
                                        <select
                                            v-model="typeform.customer_type"
                                            class="form-control"
                                            :class="{ 'is-invalid':$v.typeform.customer_type.$error }"
                                            id="customer_type"
                                            @change="onTypeChangeType()"
                                        >
                                        
                                            <option value="1">Business</option>
                                            <option value="2">Private</option>
                                        </select>
                                        <div v-if="$v.typeform.customer_type.$error" class="invalid-feedback">
                                            <span v-if="!$v.typeform.customer_type.required">{{ trans.get('__JSON__.Please select Customer Type') }}</span>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-3">
                                    <b-form-group
                                        id="input-group-2"
                                        :label="trans.get('__JSON__.Available Drivers')"
                                        label-for="Available Drivers"
                                    >
                                    </b-form-group>
                                    <span>{{available_drivers}}</span>
                                </div> 
                            </div>
                           
                         
                           
                            <!-- <div class="col-sm-3">
                                <label>{{ trans.trans('__JSON__.Busy Drivers')}}</label>
                                <span>{{busy_drivers}}</span>
                            </div>
                          -->
                            <div v-if="this.typeform.slectedDays.length > 0" id="day-driver">
                                <h4>
                                {{ trans.get("__JSON__.Add Available Driver") }}
                                </h4>
                                <div class="row" v-for="(v, i) in $v.typeform.slectedDays.$each.$iter" :key="i">
                                    <div class="col-md-3">{{v.day.$model}}</div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <input
                                                v-model.number="v.driver.$model"
                                                type="text"
                                                class="form-control"
                                                name="driver[]" 
                                                @keypress="isNumber($event)"
                                                @keyup="limitDriverInput($event, i)"
                                            />
                                            <div v-if="v.driver.$error" class="form-error">
                                                <span v-if="!v.driver.required">{{ trans.get('__JSON__.Please add driver number') }}</span>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                                    <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                                    <router-link
                                        :to="{name:'time-slot-list'}"
                                    >
                                        <b-button 
                                            type="button" 
                                            variant="secondary" 
                                            class="mt-3">
                                            {{ trans.get('__JSON__.Cancel') }}
                                        </b-button>
                                    </router-link>    
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
<style>

</style>